import { Icons } from "../../../../../../../shared/icons/icons";
import "./AboutDecorations.css";

export function HeartDrawIcon() {
  return (
    <svg
      className="about-preview__heart"
      viewBox="0 0 64 76"
      aria-hidden="true"
    >
      <path d="
        M30.5 68
        C25.5 58.5 16.5 50.5 11.8 39.8
        C7.5 30 10.2 18.5 18.2 17.5
        C25.8 16.5 29.2 25.4 30.4 34.2
        C33.3 23.6 41.2 11.2 50.1 15.6
        C58.5 19.8 55.2 35.6 48.4 46.2
        C42.7 55.1 35.4 61.9 30.5 68
      " />
    </svg>
  );
}

export function ArrowDrawIcon() {
  return (
    <svg
      className="about-preview__arrow"
      viewBox="0 0 160 90"
      aria-hidden="true"
    >
      <path d="M14 68C52 34 94 28 134 38" />
      <path d="M98 14L138 40L99 66" />
    </svg>
  );
}

export function BotanicalLeaf() {
  return (
    <svg className="about-preview__botanical" viewBox="0 0 260 560" aria-hidden="true">
      <path d="M214 532C134 438 92 337 103 238C113 143 162 67 233 18" />
      <path d="M106 166C65 160 34 184 24 229C69 235 99 211 106 166Z" />
      <path d="M119 235C74 232 39 261 29 309C75 314 111 283 119 235Z" />
      <path d="M136 307C89 310 54 346 55 394C102 390 136 354 136 307Z" />
      <path d="M158 379C116 394 91 436 101 482C143 466 167 424 158 379Z" />
      <path d="M139 103C98 98 68 122 58 165C101 170 131 145 139 103Z" />
      <path d="M170 52C134 50 106 71 96 110C133 113 161 91 170 52Z" />
    </svg>
  );
}